import { Component, OnInit, Input } from '@angular/core';
import { FindInspectionService } from '../../services/find-inspection.service';
import { InspectionRowViewModel } from '../../models/find-inspection.model';
import { Router } from '@angular/router';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'repair-estimate-list-row',
  templateUrl: './repair-estimate-list-row.component.html',
  styleUrls: ['./repair-estimate-list-row.component.scss'],
  animations: [
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )]
})
export class RepairEstimateListRowComponent implements OnInit {
  @Input() inspectionId: number;
  public inspection: InspectionRowViewModel;
  public loadingRow: boolean = true;

  constructor(private _findInspection: FindInspectionService,
    private _router: Router) { }

  ngOnInit() {
    this.loadRowData();
  }

  loadRowData() {
    this._findInspection.getRepairEstimateRow(this.inspectionId).subscribe(r => {
      console.log("getRepairEstimateRow",r)
      this.inspection = r;
      this.loadingRow = false;
    });
  }

  openInspection(inspection) {
    console.log("inspection",inspection)
    let sysTypeId = inspection.IsChain == true ? 1:2


    if(inspection.IsFrame==false){
      //this._router.navigate(['/repair-estimate', this.inspectionId,sysTypeId]);
      window.open('/repair-estimate/' + this.inspectionId + '/' + sysTypeId, '_blank');
    }
    else{
      //this._router.navigate(['/repair-estimate-frame', this.inspectionId, 3]);
      window.open('/repair-estimate-frame/' + this.inspectionId + '/3', '_blank');
    }
  }

  
}
